
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-5 h-5",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 16.667H2.917a1.25 1.25 0 01-1.25-1.25V4.583a1.25 1.25 0 011.25-1.25h14.166a1.25 1.25 0 011.25 1.25v5.025","fill":"#006430"}}),_c('path',{attrs:{"d":"M10 16.667H2.917a1.25 1.25 0 01-1.25-1.25V4.583a1.25 1.25 0 011.25-1.25h14.166a1.25 1.25 0 011.25 1.25v5.025","stroke":"#fff","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 16.667H2.917a1.25 1.25 0 01-1.25-1.25V4.583a1.25 1.25 0 011.25-1.25h14.166a1.25 1.25 0 011.25 1.25v12.084","fill":"#E1E1E1"}}),_c('path',{attrs:{"d":"M10 16.667H2.917a1.25 1.25 0 01-1.25-1.25V4.583a1.25 1.25 0 011.25-1.25h14.166a1.25 1.25 0 011.25 1.25v12.084H10z","stroke":"#fff","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.667 4.583a1.25 1.25 0 011.25-1.25h14.166a1.25 1.25 0 011.25 1.25v3.75H1.667v-3.75z","fill":"#fff","stroke":"#fff","stroke-width":"1.4"}}),_c('path',{attrs:{"d":"M3.333 5.833a.833.833 0 111.667 0 .833.833 0 01-1.667 0zm2.5 0a.833.833 0 111.667 0 .833.833 0 01-1.667 0z","fill":"#16A75C"}}),_c('path',{attrs:{"d":"M15.417 14.417a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z","stroke":"#16A75C","stroke-width":"1.4"}}),_c('path',{attrs:{"d":"M15.417 16.083v-1.666m0-2.5V10.25m-2.526 4.375l1.443-.833m2.165-1.25l1.444-.834m-5.052 0l1.443.834m2.165 1.25l1.444.833","stroke":"#16A75C","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    